import React from 'react';

export class Notify {

    addSuccessMessage = (message) => {
        message.current.show({ severity: 'success', content: 'Message Detail' });
    };

    addInfoMessage = (message) => {
        message.current.show({ severity: 'info', content: 'Message Detail' });
    };

    addWarnMessage = (message) => {
        message.current.show({ severity: 'warn', content: 'Message Detail' });
    };

    addErrorMessage = (message) => {
        message.current.show({ severity: 'error', content: 'Message Detail' });
    };

    showSuccess = (toast, detail="Opération réussie") => {
        toast.current.show({ severity: 'success', summary: '', detail: detail, life: 3000 });
    };

    showInfo = (toast, detail) => {
        toast.current.show({ severity: 'info', summary: 'Info Message', detail: detail, life: 3000 });
    };

    showWarn = (toast) => {
        toast.current.show({ severity: 'warn', summary: 'Warn Message', detail: 'Message Detail', life: 3000 });
    };

    showError = (toast, detail="Echec de l'opération") => {
        toast.current.show({ severity: 'error', summary: '', detail: detail, life: 3000 });
    };
    
}
